import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bba70320"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer has-text-centered" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = { class: "column is-2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Imprint")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "footerText" }, " Welcome to the Senckenberg Wildlive portal. This web portal is still in active development, please visit us later again! ")
], -1))
const _hoisted_6 = { class: "column is-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" About Wildlive ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/imprint",
            class: "footerText"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/about",
            class: "footerText"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}